// extracted by mini-css-extract-plugin
export default {"fullPageWrapper":"qxK2j4L2SagR9KP9YHfu","fullPageContent":"HXEplmjRcxipqvEoiNqR"};